<header class="navigation {{branding}}">
    <nav aria-label="Global">
        <!--<div class="hidden lg:block"></div>-->
        <div class="main-navigation lg:w-1/3 justify-end pr-8">
			<div [routerLink]="'/home'" class="nav-item hover:underline" [routerLinkActive]="['active']">Home</div>
			<div [routerLink]="'/bestellungen'" class="nav-item hover:underline" [routerLinkActive]="['active']">Historie</div>
        </div>
        <!-- Logo -->
        <div class="logo-container lg:w-1/3 justify-center" [routerLink]="'/'">
			@if (branding == "einhornkraut") {
				<img src="assets/images/einhornkraut-logo.avif" class="logo" [class.hidden]="mobileOpen"/>
			} @else {
				<img src="assets/images/logo-white.svg" class="logo w-30" [class.hidden]="mobileOpen"/>
			}
        </div>
        <!-- Mobile Nav Button -->
        <div class="mobile-nav-toggle-container">
            <button type="button" class="mobile-nav-toggle" (click)="toggleMobileMenu()">
                <span class="sr-only">Open main menu</span>
                <svg class="size-6" fill="black" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                     aria-hidden="true" data-slot="icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/>
                </svg>
            </button>
        </div>
        <!-- Desktop Nav -->
        <div class="main-navigation lg:w-1/3 pl-8 justify-between">
            <button class="btn-primary" [routerLink]="'/anmeldung'"
                    *ngIf="loggedInUser && loggedInUser.id == ''">
                <span class="text-md">Login</span>
                <i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
            </button>
			<button class="btn-primary" (click)="logout()"
					*ngIf="loggedInUser && loggedInUser.id != ''">
				<span class="text-md">Logout</span>
				<i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
			</button>
        </div>
    </nav>
    <!-- Mobile menu, show/hide based on menu open state.-->
    <div class="lg:hidden" [ngClass]="{'hidden': !mobileOpen}" role="dialog" aria-modal="true">
        <!-- Background backdrop, show/hide based on slide-over state. -->
        <div class="fixed inset-0 z-10"></div>
        <div
            class="fixed inset-y-0 right-0 z-10 w-full bg-preorder-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10 mobile-navigation">
            <div class="top-wrapper flex items-center justify-between">
                <div class="logo-container" [routerLink]="'/'">

					@if (branding == "einhornkraut") {
						<img src="assets/images/einhornkraut-logo.avif" class="logo"/>
					} @else {
						<img src="assets/images/logo-white.svg" class="logo logo-mobile"/>
					}
                </div>
                <i class="fa-solid fa-times text-2xl cursor-pointer pr-4" (click)="toggleMobileMenu()"></i>
            </div>
            <div class="mt-6 flow-root main-navigation px-6 py-6">
                <div class="-my-6 divide-y divide-gray-500/10">
                    <div class="space-y-2 py-8">
                        <div [routerLink]="'/home'" class="nav-item" [routerLinkActive]="['active']"
                             (click)="toggleMobileMenu()">Home
                        </div>
						<div [routerLink]="'/bestellungen'" class="nav-item" [routerLinkActive]="['active']"
							 (click)="toggleMobileMenu()">Historie
						</div>
                    </div>
                </div>
            </div>
			<div class="px-6">
				<button class="btn-primary" [routerLink]="'/anmeldung'"
						*ngIf="loggedInUser && loggedInUser.id == ''" (click)="toggleMobileMenu()">
					<span class="text-md">Login</span>
					<i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
				</button>

				<button class="btn-primary"
						*ngIf="loggedInUser && loggedInUser.id != ''" (click)="logout()">
					<span class="text-md">Logout</span>
					<i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
				</button>
			</div>
        </div>
    </div>
</header>
